var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3829 17.6929C10.3804 20.0344 10.4068 22.3862 10.356 24.723L10.2819 24.7727C9.22553 24.7499 8.14886 24.8329 7.09402 24.7841C3.20259 24.6032 0.287315 21.8485 0 17.8526V0.219315L0.0598994 0.0300715L17.6628 0C20.6557 0.143099 23.3694 2.32018 24.1719 5.27029C24.6395 6.988 24.3786 8.83999 24.4466 10.6044H17.5678L26.105 24.7815H18.0288L13.6997 17.7235C12.5957 17.665 11.4875 17.6971 10.3829 17.6929C10.3855 15.4028 10.3834 13.1112 10.3794 10.8206L10.4748 10.6044H17.5069L17.4485 7.30791L17.3531 7.09169H6.94276V17.6929C8.08846 17.696 9.23721 17.6888 10.3829 17.6929Z",
    fill: "#0A0A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/smallLogo.51dcd389a6a0da1ff689fd4a6914fe61.svg";
export { ForwardRef as ReactComponent };